import { Center, Spinner as ChakraSpinner, Text, Box } from '@chakra-ui/react';

export const Spinner = ({
  isLoading,
  text,
  position = 'absolute',
  size = 'xl',
}: {
  isLoading: boolean;
  position?: 'absolute' | 'relative';
  text?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}) => {
  return (
    <Box
      pos={position}
      top={position === 'absolute' ? '0' : 'auto'}
      left={position === 'absolute' ? '0' : 'auto'}
      right={position === 'absolute' ? '0' : 'auto'}
      bottom={position === 'absolute' ? '0' : 'auto'}
      bg="bg/80"
      zIndex={10}
      display={isLoading ? 'flex' : 'none'}
      alignItems="center"
      justifyContent="center"
    >
      <Center h="full" gap={10} flexDir="column" color="fg.subtle">
        <ChakraSpinner size={size} />
        {text && <Text fontSize="lg">{text}</Text>}
      </Center>
    </Box>
  );
};

export const SpinnerBox = ({ text }: { text?: string }) => {
  return (
    <Center height="100%" width="100%" flex={1}>
      <ChakraSpinner
        colorPalette="teal"
        h="full"
        gap={10}
        flexDir="column"
        color="fg.subtle"
      />
      {text && <Text fontSize="lg">{text}</Text>}
    </Center>
  );
};
